// extracted by mini-css-extract-plugin
export default {"PdfWrapper":"_PdfWrapper--ySNVx","PdfBoxWithFile":"_PdfBoxWithFile--zeOQT","PdfBoxWithFile1":"_PdfBoxWithFile1--keNz5","Icon":"_Icon--ld3ZW","ShowIcon":"_ShowIcon--rhj8n"};